import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import CustomButton from "shared/components/common/customButton";

interface Props extends ModalProps {
  title?: string;
  subtitle?: string;
  actionButtonText?: string;
}

const SuccessModal = ({
  title,
  subtitle,
  actionButtonText,
  show,
  handleClose,
}: Props) => {
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames("flex items-center justify-end px-4 mt-4 mb-3")}
        >
          <div
            className={classNames(styles.crossContainer)}
            onClick={handleClose}
          >
            <Icons.Cross />
          </div>
        </div>
        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-4")}
        >
          <Icons.Success className={classNames(styles.successIcon)} />
          <div className={classNames("flex flex-col gap-3 mb-4")}>
            <h6>{title ? title : "Your questionnaire has been submitted successfully!"}</h6>
            {/*<p>
              {subtitle
                ? subtitle
                : "Your questionnaire has been submitted successfully!"}
            </p>*/}
          </div>
          <CustomButton
            title={actionButtonText ? actionButtonText : "Close"}
            containerStyle={styles.actionButton}
            onClick={handleClose}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default SuccessModal;
